import { render, staticRenderFns } from "./hhyc.vue?vue&type=template&id=1e248957&scoped=true"
import script from "./hhyc.vue?vue&type=script&lang=js"
export * from "./hhyc.vue?vue&type=script&lang=js"
import style0 from "./hhyc.vue?vue&type=style&index=0&id=1e248957&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e248957",
  null
  
)

export default component.exports